<template>
  <div class="orderdetails" v-if="orderInfo">
    <!-- 幸福星期天 -->
    <div class="back-luck-sunday" v-if="orderInfo.source == 'luckSunday' || showHappySunday">
      幸福星期天品牌特卖 >
      <wx-open-launch-weapp
        style="position: absolute;width: 100%;height: 100%;top:0;left:0"
        username="gh_3318973708df"
        path="happySunday/pages/index/index">
        <script type="text/wxtag-template">
          <style>.btn {position: absolute;top:0;left:0;width:100%;height:100%;opacity:0}</style>
          <button class="btn"></button>
        </script>
      </wx-open-launch-weapp>
    </div>
    <h2 @click="openDialog">{{ orderInfo.orderStatusTitle }} ></h2>
    <div class="mask" v-if="orderInfoVisible">
      <div class="dialog-order br20">
        <ul class="main no-foot mydialog" v-if="orderStatus != ''">
          <li class="order-list" v-for="item in orderInfo.flowList">
            <div class="order-cards icon">
              <div class="cards-first ">
                <div class="cards-title">{{ item.title }}</div>
                <div>{{ item.time }}</div>
              </div>
              <div class="cards-sec">
                {{ item.subTitle }}
                <a class="shop-tel-icon" :href="'tel:'+ item.mobile" v-if="item.mobile"
                   style="border-left: none;width: .4rem;padding-left: .2rem;margin-left: 0"></a>
              </div>
            </div>

          </li>
        </ul>
        <div class="mybnt">
          <div @click="orderInfoVisible = false">关 闭</div>
        </div>
      </div>
    </div>
    <div class="orderProgress">
      <div class="subTitle">{{ orderInfo.orderStatusSubTitle }}</div>
      <!-- 1分钟免责取消订单 -->
      <div class="fs-24 mb20" v-if="orderInfo.orderFuncStr">{{orderInfo.orderFuncStr}}</div>
      <!-- 准时达 -->
      <div class="fs-20 fw-bold flex-row-sc mb20" v-if="orderInfo.beGuaranteed === 1" @click="viewPunctual()">
        <img src="../assets/images/icon-punctual-arrive.png" class="mr10" style="width: .24rem;"/>
        {{orderInfo.guaranteeTitle}}
        <div class="fs-20 fc-999 ml10 flex-row-sc">
          {{orderInfo.guaranteeStatusStr}}
          <img src="../assets/images/arrow-right.png" class="ml10" style="width: .1rem;"/>
        </div>
      </div>
      <div class="progress-contain">
        <a v-if="orderStatus == 1000" class="btn-ellipse border moreOrder-padding " @click="clickHandle(2)">立即支付</a>
        <a v-if="orderStatus == 1000" class="btn-ellipse border moreOrder-padding "
           @click="cancelOrder(orderId)">取消订单</a>
        <a class=" btn-ellipse border moreOrder-padding "
           v-if="orderStatus==2002 || orderStatus==3001 ||orderStatus==9000"
           @click="moreOrder(orderId,orderInfo.supplier_id, orderInfo.supplier_name)">再来一单</a>
        <a v-if="orderStatus > 1000 && orderStatus<3001" class="btn-ellipse border moreOrder-padding"
           @click="clickHandle(3)">确认收货</a>
        <a class=" btn-ellipse border moreOrder-padding" v-if="orderInfo.reminderButton == 1"
           @click="reminderOrder(orderId)">催单</a>
        <a class="btn-ellipse moreOrder-padding border" @click="clickHandle(1)"
           v-if="(orderInfo.refundStatus==1 && !orderInfo.cancelLeftSeconds) && (orderStatus ==1001 || orderStatus == 2001 || orderStatus == 2002 ||  orderStatus == 3001)">申请售后
        </a>
        <a v-if="canEstimated == 1" class="btn-ellipse border moreOrder-padding " @click="clickHandle(5)">评价</a>
        <!-- <a v-if="estimateId != '' && estimateId != undefined && estimateId != null"
           class="btn-ellipse border moreOrder-padding " @click="clickHandle(6)">查看评价</a> -->
        <a
          v-if="orderInfo.refundStatus==3 &&(orderStatus==3001 || orderStatus==2001 || orderStatus==2002 ||orderStatus==1001)"
          class="btn-ellipse border moreOrder-padding" @click="clickHandle(8)">退款进度</a>
        <!-- 一分钟内取消订单并退款   -->
        <a v-if="orderInfo.cancelLeftSeconds>0  && (orderStatus ==1001 || orderStatus == 2001 || orderStatus == 2002 ||  orderStatus == 3001)" class="btn-ellipse border moreOrder-padding "
        @click="cancelAndRefundOrder(orderId)">取消订单</a>
      </div>
    </div>

    <div class="main no-foot" v-if="orderStatus != ''">
      <div class="aftermarket-results br20" v-if="orderInfo && orderInfo.showShopRefund == 1">
        商家修改了您的退款商品，请点击:查看售后->退款进度 查看详情，如对商家处理结果不满，您可发起申诉申请平台介入。
      </div>
      <div class="aftermarket-results br20" v-if="orderInfo && orderInfo.showShopRefund == 2">
        商家拒绝了该退款申请，请点击:查看售后->退款进度 查看详情，如对商家处理结果不满，您可发起申诉申请平台介入。
      </div>
      <div class="aftermarket-results br20" v-if="orderInfo && orderInfo.showShopRefund == 3">
        商家同意了退款申请，退款金额将在2个工作日左右到账。
      </div>
      <!--orderType 1:自提 3：堂食-->
      <!--堂食码-->
      <div class="food-code br20" v-if="orderInfo.pickUpCode &&　orderInfo.orderType == 3 && orderStatus != 3001">
        <div style="font-size: .28rem; color: #4A4A4A;">堂食取餐码</div>
        <div class="qr-code" @click="toQrCode(orderInfo.orderShortNumQrCode)">
          <img src="../assets/images/code-er.png" alt="" style="width: .29rem;height: .29rem;">
          <span class="fz-28" style="color: #F2596C;margin-left: .15rem;">二维码</span>
          <span class="qr-line"></span>
          <span style="font-size: 0.32rem;color: #F2596C;margin-left: .32rem;">{{ orderInfo.pickUpCode }}</span>
        </div>
      </div>
      <!--自提-->
      <!--orderStatus  3001：确认收货  9000：已取消-->
      <!--orderPickUpInfoBean 表示是否已经存柜子-->
      <div v-if="orderInfo.orderType == 1">
        <div class="self-take-addr br20">
          <p style="font-size: 0.24rem;color: #787878;">{{ orderInfo.orderPickUpInfoBean ? '自提柜地址' : '自提地点' }}</p>
          <div class="clearflow">
            <h3 class="fl">
              {{
                orderInfo.orderPickUpInfoBean ? orderInfo.orderPickUpInfoBean.deviceAddress : orderInfo.pickUpAddr
              }}</h3>
            <span class="check-map fr" @click="toCheckMap" v-if="!orderInfo.orderPickUpInfoBean">查看</span>
          </div>
        </div>
        <div class="self-take-box br20" v-if="orderStatus != 3001">
          <div class="self-take-code" style="border-top: none">
            <span class="color-grey fz-28">{{ orderInfo.orderPickUpInfoBean ? '存餐员联系电话' : '商家联系电话' }}</span>
            <a :href="'tel:'+ orderInfo.supplierTel"
               style="font-size: 0.32rem;color: #F2596C;">{{
                orderInfo.orderPickUpInfoBean ? orderInfo.orderPickUpInfoBean.deliveryTel : orderInfo.supplierTel
              }}</a>
          </div>
          <div class="self-take-code"
               v-if="orderStatus > 1000 && orderStatus != 9000 && !orderInfo.orderPickUpInfoBean">
            <span class="color-grey fz-28">取货码</span>
            <div class="qr-code" @click="toQrCode(orderInfo.orderShortNumQrCode)">
              <img src="../assets/images/code-er.png" alt="" style="width: .29rem;height: .29rem;">
              <span class="fz-28" style="color: #F2596C;margin-left: .15rem;">二维码</span>
              <span class="qr-line"></span>
              <span style="font-size: 0.32rem;color: #F2596C;margin-left: .32rem;">{{ orderInfo.pickUpCode }}</span>
            </div>
          </div>
        </div>
        <div class="self-take-box br20" v-if="orderInfo.buildingAddress && orderInfo.buildingAddress.length > 0">
          <div class="self-take-code" style="border-top: none">
            <span class="color-grey fz-28">宿舍信息</span>
            <span>{{ orderInfo.buildingAddress }}</span>
          </div>
        </div>
      </div>
      <!--自提柜信息 华农-->
      <div class="selfInfo br20" v-if="orderInfo.orderPickUpInfoBean && orderInfo.orderPickUpInfoBean.takeType == 0">
        <div class="selfCode" v-if="orderInfo.orderPickUpInfoBean.takeStatus == '0'">
          <div class="selfDes">自提柜取餐码
            <span
              class="takeCode">{{
                orderInfo.orderPickUpInfoBean.takeCode ? orderInfo.orderPickUpInfoBean.takeCode : '无'
              }}</span>
          </div>
          <div class="selfInfo-wrap">
            <span class="selfBtn" @click="showSelfInfo">自提柜信息</span>
            <!--<span class="openCabinet" v-if="orderInfo.orderPickUpInfoBean.haveOpenButton == 1" @click="openCabinet">一键开柜</span>-->
          </div>
        </div>
        <div class="selfSuc"
             v-if="orderInfo.orderPickUpInfoBean.takeStatus == '2' || orderInfo.orderPickUpInfoBean.takeStatus == '3' ">
          {{ orderInfo.orderPickUpInfoBean.takeName }}
        </div>
      </div>
      <!--自提柜信息 双凯-->
      <div class="selfInfo1 br20" v-if="orderInfo.orderPickUpInfoBean && orderInfo.orderPickUpInfoBean.takeType == 1">
        <div class="fz-32">
          <img class="dingwei" src="../assets/images/icon-dingwei@2x.png"/>
          {{ orderInfo.orderPickUpInfoBean.deviceName }}
        </div>
        <div class="cell-no">
          <div class="status" v-if="orderInfo.orderPickUpInfoBean.takeStatus == 0">待取</div>
          <!-- <div class="status" v-if="{{orderInfo.orderPickUpInfoBean.takeStatus == 1}}">撤餐</div> -->
          <div class="status" style="background: #7ED321;color:#fff"
               v-if="orderInfo.orderPickUpInfoBean.takeStatus == 2">已取
          </div>
          <div class="status" style="background: #D51A2A;color:#fff"
               v-if="orderInfo.orderPickUpInfoBean.takeStatus == 3">废餐
          </div>
          <div class="no">
            {{ orderInfo.orderPickUpInfoBean.cellNo }}
          </div>
          <div class="fz-24" style="color: #797979">箱号</div>
        </div>
        <div class="fz-28">存餐时间：{{ orderInfo.orderPickUpInfoBean.saveTimeStr }}</div>
        <div class="fz-28" v-if="orderInfo.orderPickUpInfoBean.takeStatus == 2">
          取餐时间：{{ orderInfo.orderPickUpInfoBean.takeTimeStr }}
        </div>
        <div class="fz-28" v-if="orderInfo.orderPickUpInfoBean.takeStatus == 3">
          废餐时间：{{ orderInfo.orderPickUpInfoBean.lockTimeStr }}
        </div>
        <div class="btn-open" style="margin: .14rem 0 .2rem 0" v-if="orderInfo.orderPickUpInfoBean.takeStatus==0"
             @click="openCabinet">一键开柜
        </div>
        <div class="btn-open disabled" v-if="orderInfo.orderPickUpInfoBean.takeStatus==2">已取餐</div>
        <div class="btn-open disabled" v-if="orderInfo.orderPickUpInfoBean.takeStatus==3">已废餐</div>
        <div class="fc-grey-light" v-if="orderInfo.orderPickUpInfoBean.takeStatus == 0">
          <!--<rich-text nodes="{{orderInfo.orderPickUpInfoBean.msgTemplate}}"></rich-text>-->
          <div v-html="orderInfo.orderPickUpInfoBean.msgTemplate"></div>
        </div>
      </div>
      <!--打赏西游侠-->
      <div class="reward-box"
           v-if="(orderInfo.order_status === 2001 || orderInfo.order_status === 2002 || orderInfo.order_status === 3001) && orderInfo.deliveryNickName">
        <div style="display: flex;align-items: center;">
          <img :src="orderInfo.deliveryAvatar" alt="" style="width: .6rem;height: .6rem;border-radius: 50%">
          <div class="delivery-name">{{ orderInfo.deliveryNickName }}</div>
        </div>
        <a  v-if="orderInfo.canContactDelivery" :href="'tel:'+ orderInfo.deliveryPhone" class="order-tel1" style="width: 1.8rem">联系西游侠</a>
        <div class="delivery-btn" v-else @click="toReward(orderInfo.order_id)">打赏西游侠</div>
      </div>

      <div class="list order-list" style="margin: 0;">
        <ul class="br20">
          <li class="title flexrow" style="justify-content: space-between">
            <div style="width: 100%">
              <div class="flexrow" style="justify-content: space-between;align-items: center;margin-bottom: 0.15rem;">
                <span class='shop-name ellipse'
                      @click="toGoodsList(orderInfo.supplier_id, orderInfo.supplier_name)">{{
                    orderInfo.supplier_name
                  }}</span>
                <span class="flexrow">
                  <a  v-if="managerInfo.mp" :href="'tel:'+ managerInfo.mp" class="order-tel">联系本校客服</a>
                  <a  :href="'tel:'+ orderInfo.supplierTel" class="order-tel1">联系商家</a>
                </span>
              </div>
              <div class="order-id">单号：<span id="codeNum">{{ orderInfo.order_id }}</span><span class="copy" @click="copy()">复制</span>
              </div>
            </div>
<!--            <div class="arrow-right" style="width: 20%;height: 0.6rem"-->
<!--                 @click="toGoodsList(orderInfo.supplier_id, orderInfo.supplier_name)"></div>-->
          </li>
          <li>
            <div class="goods-list">
              <div v-for="item in orderInfo.goods_list" class="clearflow goods-container">
                <div class='goods-img fl' :style="{backgroundImage:'url(' + item.image+')'}"></div>
                <div class="fl flexcol" style="margin:0;width:65%;">
                  <span class="goods-name" style="font-weight: bold; width:100%">{{ item.name }}</span>
                  <span class="goods-spec" v-if="item.specification">{{ item.specification }}</span>
                  <span class="goods-spec" v-if="item.attribute">{{ item.attribute }}</span>
                </div>
                <div class='flexcol' style='align-items: flex-end'>
                  <div class="flexrow">
                    <span class="pri ori_pri"
                          v-if="item.originalGdAmount != null && item.originalGdAmount != '' && item.originalGdAmount != undefined">￥{{
                        item.originalGdAmount
                      }}</span>
                    <span class="pri ori_pri" v-else></span>
                    <span
                      :class="['pri',{on: item.originalGdAmount != null && item.originalGdAmount != '' && item.originalGdAmount != undefined}]">￥{{
                        item.gdAmount
                      }}</span>

                  </div>
                  <span class="goods_num">x{{ item.buyNum }}</span>
                </div>

              </div>
              <div class="gift-info clearflow"
                   v-if="orderInfo && orderInfo.gift_list && orderInfo.gift_list.length > 0">
                <div class="fl flexrow" style="width: 30%;align-items: center">
                  <img :src="orderInfo.gift_url" alt="">
                  <span>{{ orderInfo.gift_activity_name }}</span>
                </div>
                <span class="fr"
                      v-if="orderInfo.gift_list[0].name.length < 10">{{
                    orderInfo.gift_list[0].name
                  }}x{{ orderInfo.gift_list[0].buyNum }}</span>
                <span class="fr"
                      v-else>{{ orderInfo.gift_list[0].name.substring(0, 10) }}...x{{
                    orderInfo.gift_list[0].buyNum
                  }}</span>
              </div>
              <!--<br/>-->
              <!--订单相关费用-->
              <!--<div style="margin-top: 0.26rem;font-size: .26rem;">商品总价 <span class="fr">￥{{orderInfo.amount}}</span></div>-->
              <!--<div style="margin-top: 0.14rem;font-size: .26rem;" v-if="orderInfo.extraFeeTitle && orderInfo.extraFee">{{orderInfo.extraFeeTitle}} <span class="fr">￥{{orderInfo.extraFee}}</span></div>-->
              <!--<div style="margin-top: 0.14rem;font-size: .26rem;">{{orderInfo.greenTax}} <span class="fr">￥{{orderInfo.package_fee}}</span></div>-->
              <!--<div style="margin-top: 0.14rem;font-size: .26rem;" v-if="orderInfo.orderType==1 || orderInfo.orderType==3">服务费 <span class="fr">￥{{orderInfo.delivery_fee}}</span></div>-->
              <!--<div style="margin-top: 0.14rem;font-size: .26rem;" v-if="orderInfo.orderType==0">配送费 <span class="fr">￥{{orderInfo.delivery_fee}}</span></div>-->
              <!--<div style="margin-top: 0.14rem;font-size: .26rem;" v-if="orderInfo.orderType==0 && orderInfo.serviceFee">服务费 <span class="fr">￥{{orderInfo.serviceFee}}</span></div>-->
              <!--<div style="margin-top: 0.14rem;font-size: .26rem;" v-if="orderInfo.couponAmount != 0">优惠券减免 <span class="fr">-￥{{orderInfo.couponAmount}}</span></div>-->
              <!--<div style="margin-top: 0.14rem;font-size: .26rem;" v-if="orderInfo.reductionAmount && orderInfo.reductionAmount != 0">满减优惠 <span class="fr">-￥{{orderInfo.reductionAmount}}</span></div>-->
              <div style="margin-top: 0.26rem;font-size: .26rem;" v-for="item in orderInfo.orderFeeList">
                <span :style="{color: item.titleColor}">{{ item.title }}</span>
                <span :style="{color: item.valueColor}" class="fr ml10">{{ item.value }}</span>
                <span v-if="item.originValue" class="fr"
                      style="text-decoration: line-through;color: #ff0000">{{ item.originValue }}</span>
              </div>
            </div>
          </li>
          <li>
            <div class="goods-list foot">
              <span class="fr">总计 <span class="c-red"
                                        style="font-size: 0.36rem;font-weight: bold;">￥{{
                  orderInfo.real_pay
                }}</span></span>
            </div>
          </li>
        </ul>
        <ul class="order-info br20">
          <li>
            <div class="goods-list details">
              <div style="margin-top: 0.14rem;"><span class="label">订单状态</span> <span>{{ orderDesc }}</span></div>
              <div style="margin-top: 0.14rem;" v-if="orderInfo.orderType==0"><span class="label">送达时间</span>
                <span>{{ orderInfo.delivery_time }}</span></div>
              <div style="margin-top: 0.14rem;" v-if="orderInfo.orderType==1"><span class="label">自提时间</span>
                <span>{{ orderInfo.delivery_time }}</span></div>
              <div style="margin-top: 0.14rem;" v-if="orderInfo.orderType==3"><span class="label">就餐时间</span>
                <span>{{ orderInfo.delivery_time }}</span></div>
              <div style="margin-top: 0.14rem;" v-if="orderInfo.upstairsDeliveryStr"><span class="label">配送方式</span>
                <span>{{ orderInfo.upstairsDeliveryStr }}</span></div>
              <div style="margin-top: 0.14rem;" v-if="orderInfo.orderType==0">
                <span class="label">收货地址</span>
                <span>{{ orderInfo.consignee }} {{ orderInfo.consignee_tel }}<br/>{{ orderInfo.address }}</span>
              </div>
              <div style="margin-top: 0.14rem;" v-if="orderInfo.orderType==1"><span class="label">自提电话</span>
                <span>{{ orderInfo.consignee_tel }}</span></div>
              <div style="margin-top: 0.14rem;" v-if="orderInfo.orderType==3"><span class="label">预留电话</span>
                <span>{{ orderInfo.consignee_tel }}</span></div>
              <div style="margin-top: 0.14rem;"><span class="label">订单时间</span> <span>{{ orderInfo.create_time }}</span>
              </div>
              <div style="margin-top: 0.14rem;" v-if="orderInfo.comment"><span class="label">订单备注</span>
                <span>{{ orderInfo.comment }}</span></div>
              <div style="margin-top: 0.14rem;" v-if="orderInfo.paywayStr"><span class="label">支付方式</span>
                <span>{{ orderInfo.paywayStr }}</span></div>
              <div v-if="orderInfo.singleItemCouponName"><span class="label">&nbsp;&nbsp;&nbsp;&nbsp;</span> <span
                style="font-size: .18rem;color:#707070">优惠说明：本单参与{{
                  orderInfo.singleItemCouponName
                }}，共享受优惠{{ orderInfo.singleItemAmount }}元</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="order-info">
        <li v-for="text in orderInfo.text_info">{{ text.txt }}<span class="fr">￥{{ text.val }}</span></li>
      </div>
    </div>
    <div class="service mask" v-if="serviceList" @click="closeServiceList" @touchmove.prevent>
      <ul class="list">
        <li class="arrow-right">
          <div v-if="orderInfo.isFinishAfter24H==0">
            <p v-if="complaint == 3||complaint == 2" @click="clickHandle(9)">在线投诉</p>
          </div>
          <div v-if="orderInfo.isFinishAfter24H==1">
            <p v-if="complaint == 3||complaint == 2" @click="clickHandle(11)">
              <a :href="'tel:'+ tel">在线投诉</a>
            </p>
          </div>
          <p v-if="complaint == 1" @click="clickHandle(10)" style="margin: 0">查看投诉</p>
        </li>
        <li class="arrow-right" v-if="orderInfo.refundStatus!=2">
          <p v-if="orderInfo.refundStatus==1" @click="clickHandle(7)">申请退款</p>
          <p v-if="orderInfo.refundStatus==3" @click="clickHandle(8)">退款进度</p>
        </li>
      </ul>
    </div>
    <!--红包弹框-->
    <div class="redPacketAlert" v-if="isShowRedPacket" @touchmove.prevent>
      <div class="redPacketBox">
        <div class="redPacketClose" @click="isShowRedPacket = false"></div>
        <div style="padding: 0.3rem 0.5rem ">
          <h3>{{ redPacketInfo.show_title }}</h3>
          <p>{{ redPacketInfo.show_content }}</p>
          <div class="redPacket" :style="{backgroundImage:'url(' + redPacketInfo.show_pic+')'}"></div>
        </div>
        <div class="redPacketBtn" @click="wxShareMask = true">发红包</div>
      </div>
    </div>
    <!--红包icon-->
    <div
      v-if="orderStatus > 1000 && orderInfo.redPacket != undefined && orderInfo.redPacket != null"
      class="redPacketIcon"
      @click="wxShareMask = true"
      :style="{backgroundImage:'url(' + orderInfo.redPacket.show_pic+')'}">

    </div>
    <!--微信分享引导弹层-->
    <div class="wxShareTips" v-if="wxShareMask" @click="wxShareMask = false" @touchmove.prevent>
      <div class="wxShareImg"></div>
    </div>
    <!--自提柜信息弹框-->
    <div v-if="isShowSelf" class="selfWrap" @touchmove.prevent @click="isShowSelf = false">
      <div class="self-mask">
        <div class="self-top">自提柜信息</div>
        <div class="self-name" style="margin-bottom: .32rem;">
          <span class="name-left fl">自提柜名称</span>
          <span class="name-right fl">{{ orderInfo.orderPickUpInfoBean.deviceName }}</span>
        </div>
        <div class="self-name" style="margin-bottom: .32rem;">
          <span class="name-left fl">自提柜地址</span>
          <span class="name-right fl">{{ orderInfo.orderPickUpInfoBean.deviceAddress }}</span>
        </div>
        <div class="self-name">
          <span class="name-left fl">格子号</span>
          <span class="name-right fl">{{ orderInfo.orderPickUpInfoBean.cellNo }}</span>
        </div>
        <div class="closeBtn" @click="isShowSelf = false">确定</div>
      </div>
    </div>
    <!-- 自提柜信息 -->
    <div v-if="isShowCabinet" class="selfWrap">
      <div class="self-mask" style="width: 6.4rem;margin-left: -3.2rem;margin-top:-3rem;padding-top: 0">
        <!--<div class="self-cab">自提柜信息：</div>-->
        <!--<div class="self-name-cab" style="margin-bottom: .32rem;">-->
        <!--餐柜名称：{{orderInfo.orderPickUpInfoBean.deviceName}}-->
        <!--</div>-->
        <!--<div class="self-name-cab">-->
        <!--格子号：{{orderInfo.orderPickUpInfoBean.cellNo}}-->
        <!--</div>-->
        <!--<div class="cab-tip">请确保在自提柜附近操作开柜，防止餐品丢失。</div>-->
        <!--<div class="closeBtn" @click="isShowSelf = false">-->
        <!--<span class="sure-cab-btn" @click="sureCabinet">确认开柜</span>-->
        <!--<span class="cancel-cab-btn" @click="cancelCab">取消</span>-->
        <!--</div>-->
        <div class="selfInfo1" style="padding: .7rem .4rem .5rem .4rem;margin-bottom: 0;background-color: transparent">
          <div class="fz-32">
            <img class="dingwei" src="../assets/images/icon-dingwei@2x.png"/>
            {{ orderInfo.orderPickUpInfoBean.deviceName }}
          </div>
          <div class="cell-no" style="width: 1.8rem">
            <div class="no" style="font-size: 1.2rem">
              {{ orderInfo.orderPickUpInfoBean.cellNo }}
            </div>
            <div class="fz-32" style="color: #797979">箱号</div>
          </div>
          <div style="margin: .4rem 0">请确保在自提柜附近操作开柜，防止餐品丢失。</div>
          <div class="btn-open" style="height:.84rem;line-height:.84rem;margin-bottom: .2rem" v-if="!isShowProgress"
               @click="sureCabinet">确认开柜
          </div>
          <div class="progressbar" v-if="isShowProgress">
            <div class="fill"></div>
          </div>
          <div class="btn-cancle" @click="cancelCab">取消开柜</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// var wx = require('weixin-js-sdk')
import {actions} from '../store/actions'
import _ from "lodash";
// import { MessageBox, Toast, Indicator} from 'mint-ui'

export default {
  data() {
    return {
      orderId: 0,
      orderInfo: null,
      orderStatus: '',
      payStatus: '',
      settle_amount: 0,
      orderDesc: '',
      estimateId: '',
      canEstimated: '',
      complaint: '',
      tel: '',
      serviceList: false,
      isShowRedPacket: false,
      redPacketInfo: {},//红包信息
      wxShareMask: false,
      isShowSelf: false,
      isShowCabinet: false,
      isShowProgress: false,
      defaultGoodsList: [],
      anotherGoodsList: [],
      cartData: {},
      changeGoodsInCart: [],
      schoolCardCode: '',
      orderInfoVisible: false,
      showHappySunday: false, //显示幸福星期天
      managerInfo: {}, //获取客服信息
    }
  },
  computed: {
    cartInfo() {
      return this.$store.state.cartInfo
    },
    schoolInfo() {
      return this.$store.state.schoolInfo
    },
    wxUid() {
      return this.$store.state.wxUid
    }
  },
  // created () {
  //   document.title = '订单详情'
  // },
  beforeRouteLeave(to, from, next) {
    if (to.name == 'OrderList') {
      to.meta.isUseCache = true;
    }
    next()
  },
  mounted() {
    var _this = this
    if(!_this.$store.state.wxLoginToken){
      _this.$utils.toLogin(_this);
      return;
    }
    if (_this.$utils.resolveUrl().order_id) {
      _this.orderId = _this.$utils.resolveUrl().order_id
    } else {
      _this.orderId = window.localStorage.getItem('orderCode')
    }
    if (_this.$utils.resolveUrl().school_id) {
      actions.postSchoolStatus(_this, {school_id: _this.$utils.resolveUrl().school_id}, function (data) {
        let schoolInfo = {
          schoolId: data.school_id,
          schoolName: data.school_name
        }
        _this.$store.commit('changeSchoolInfo', schoolInfo)
      }, function () {
        _this.$messagebox.alert(data.body.message, '')
      })
    }
    _this.getOrderDetail()

    if (!_this.$utils.isWeiXin()) {
      window.onpopstate = () => {
        // alert('1')
        _this.$router.push({name: 'OrderList'})
      }
    }
  },
  methods: {
    //客服信息
    getManagerInfo(){
      var _this = this
      var param = {
        school_id: _this.orderInfo.schoolId,
      }
      actions.managerInfo(_this, param, function (data) {
        if(data){
          _this.managerInfo = data
        }
      })
    },
    //打开出餐进程
    openDialog() {
      this.orderInfoVisible = true
    },

    //一键开柜
    openCabinet() {
      this.isShowCabinet = true;
    },
    sureCabinet() {
      var _this = this
      let params = {
        operateType: 0,
        order_id: _this.orderId
      }
      // _this.$indicator.open({text: '开柜中'})
      _this.isShowProgress = true;
      actions.openCabinet(_this, params, function (data) {
        _this.isShowCabinet = false;
        _this.isShowProgress = false;
        _this.$router.push({path: `/deviceDetail/${_this.orderId}`})
      }, function (data) {
        // _this.$indicator.close();
        _this.isShowProgress = false;
        _this.$toast(data.data.message);
      })
    },
    cancelCab() {
      this.isShowCabinet = false;
      this.isShowProgress = false;
    },
    //复制
    copy() {
      const range = document.createRange();
      range.selectNode(document.getElementById('codeNum'));
      const selection = window.getSelection();
      if (selection.rangeCount > 0) selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand('copy');
      this.$toast('复制成功')
    },
    //取餐二维码
    toQrCode(val) {
      window.localStorage.setItem('Qr-code', val);
      this.$router.push({
        path: 'QrCode',
        query: {orderType: this.orderInfo.orderType}
      })
    },
    // 查看自提点地图
    toCheckMap: function () {
      window.localStorage.setItem('mapAddr', this.orderInfo.pickUpAddr);
      window.localStorage.setItem('mapPic', this.orderInfo.pickUpImage);
      this.$router.push({name: 'Map'})
    },
    getOrderDetail: function () {
      var _this = this
      var param = {
        order_id: _this.orderId
      }
      actions.getOrderDetail(_this, param, function (data) {
        data.supplierTel = data.supplierTel ? data.supplierTel.substring(0, 3) + ' ' + data.supplierTel.substring(3, 7) + ' ' + data.supplierTel.substring(7, 11) : '';
        if (data.orderPickUpInfoBean && data.orderPickUpInfoBean.msgTemplate && data.orderPickUpInfoBean.msgParam) {
          let msgTemplate = data.orderPickUpInfoBean.msgTemplate;
          data.orderPickUpInfoBean.msgTemplate = msgTemplate.replace(/%s分钟/, `<span style="color:#ff0000">${data.orderPickUpInfoBean.msgParam}分钟</span>`);
        }
        // console.log(data.supplierTel)
        _this.orderInfo = data;
        _this.orderStatus = _this.orderInfo.order_status;
        _this.payStatus = _this.orderInfo.pay_status;
        _this.canEstimated = _this.orderInfo.canEstimated;
        _this.estimateId = _this.orderInfo.estimateId;
        _this.complaint = _this.orderInfo.complaint;
        _this.complainId = _this.orderInfo.complaintId;

        _this.getManagerInfo() //获取客服信息
        if (_this.orderInfo.redPacket && _this.orderInfo.order_status > 1000) {
          // actions.getredPacketShare(_this, {order_id: _this.orderId}, function (data) {
          //   if (data) {
          //     _this.redPacketInfo = data;
          //     _this.isShowRedPacket = true;
          //   }
          // }, function () {})
          // _this.$utils.wxShareNew(
          //   _this,
          //   _this.orderInfo.redPacket.share_title, // 分享标题
          //   _this.orderInfo.redPacket.url, // 分享链接
          //   _this.orderInfo.redPacket.share_pic, // 分享图标
          //   _this.orderInfo.redPacket.share_content // 分享描述
          // );
          //红包分享
          // var u = encodeURIComponent(window.location.href.split('#')[0])
          // window.localStorage.setItem('landingPage', u)
          // actions.getJsShareConf(_this, u, function (data) {
          //   wx.config({
          //     debug: false,//开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          //     appId: data.data.appId, // 必填，公众号的唯一标识
          //     timestamp: data.data.timestamp, // 必填，生成签名的时间戳
          //     nonceStr: data.data.nonceStr, //必填， 生成签名的随机串
          //     signature: data.data.signature, //必填，签名
          //     jsApiList: data.data.jsApiList  //必填， JS接口列表，这里只填写了分享需要的接口
          //   });
          //   wx.ready(function () {
          //     _this.$utils.wx_share(
          //       _this.orderInfo.redPacket.share_title, // 分享标题
          //       _this.orderInfo.redPacket.url, // 分享链接
          //       _this.orderInfo.redPacket.share_pic, // 分享图标
          //       _this.orderInfo.redPacket.share_content // 分享描述
          //     );
          //   });
          //   wx.error(function (res) {
          //     // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
          //   })
          // })
        }
        var obj = {
          commercialId: data.commercialId
        };
        _this.$store.commit('changeState', obj);
        if (_this.orderInfo.orderType === 0) {
          if (_this.orderStatus === 1000) {
            _this.orderDesc = '待付款'
          } else if (_this.orderStatus === 1001) {
            _this.orderDesc = '已支付'
          } else if (_this.orderStatus === 2001) {
            _this.orderDesc = '配送中'
          } else if (_this.orderStatus === 2002) {
            _this.orderDesc = '配送完成'
          } else if (_this.orderStatus === 3001) {
            _this.orderDesc = '确认收货'
          } else if (_this.orderStatus === 9000) {
            _this.orderDesc = '已取消'
          } else if (_this.orderStatus === -8000) {
            _this.orderDesc = '订单错误'
          }
        } else if (_this.orderInfo.orderType === 1) {
          if (_this.orderStatus === 1000) {
            _this.orderDesc = '待付款'
          } else if (_this.orderStatus === 1001) {
            _this.orderDesc = '待领取'
          } else if (_this.orderStatus === 3001) {
            _this.orderDesc = '已完成'
          } else if (_this.orderStatus === 9000) {
            _this.orderDesc = '已取消'
          }
        } else if (_this.orderInfo.orderType === 3) {
          if (_this.orderStatus === 1000) {
            _this.orderDesc = '待付款'
          } else if (_this.orderStatus === 1001) {
            _this.orderDesc = '备餐中'
          } else if (_this.orderStatus === 2001) {
            _this.orderDesc = '待领取'
          } else if (_this.orderStatus === 3001) {
            _this.orderDesc = '已完成'
          } else if (_this.orderStatus === 9000) {
            _this.orderDesc = '已取消'
          }
        }
        window.localStorage.setItem('deliveryTime', data.eatIn_time)
        window.localStorage.setItem('supplier_name', data.supplier_name)
        window.localStorage.setItem('qrCodeIndate', data.qrCodeIndate)
        window.localStorage.setItem('isInvalid', data.isInvalid)
        _this.isShowHappySunday();
      })
    },
    toGoodsList: function (id, name) {
      var _this = this;
      var obj = {
        shop_code: id,
        shop_name: name,
        showBlockType: 'orderDishes'
      };
      _this.$store.commit('changeState', obj);
      _this.$router.push({name: 'GoodsList'})
    },
    // 取消订单
    cancelOrder: function (id) {
      this.$messagebox.confirm('确定取消订单吗?', '').then(action => {
        var _this = this
        var params = {
          order_id: id
        }
        actions.postCancelOrder(_this, params, function (data) {
          _this.$toast('取消成功')
          _this.getOrderDetail()
        })
      }).catch(() => {

      })
    },
    // 取消订单并退款
    cancelAndRefundOrder: function (id) {
      this.$messagebox.confirm('当前售后申请无需审核，将直接为您退款，是否确认取消订单？', '取消订单并退款').then(action => {
        var _this = this
        var params = {
          orderId: id
        }
        actions.postCancelRefundOrder(_this, params, (res) =>{
          if(res.flag){
            let flag = res.flag;
            if(flag === 1){
              this.$toast('取消并退款成功');
              this.getOrderDetail();
            }else{
              this.$messagebox.alert(res.msg || res.message, '');
            }
          }
        },(res)=>{
          this.$messagebox.alert(res.msg || res.message, '');
        })
      }).catch(() => {

      })
    },
    // 催单
    reminderOrder: function (id) {
      var _this = this
      var params = {
        order_id: id
      }
      actions.reminderOrder(_this, params, function (data) {
        _this.$toast(data.msg)
        // _this.getOrderDetail()
      })
    },
    closeServiceList: function () {
      this.serviceList = false
    },
    getSchoolCardInfo() {
      let _this = this;
      // _this.orderSubmitType = 2;
      actions.schoolCardInfo(_this, {school_id: _this.orderInfo.schoolId}, function (data) {
        if (data && data.card_no) {
          _this.schoolCardCode = data.card_no;
        } else {
          _this.schoolCardCode = '';
        }
        _this.cfPay();
      }, function () {
        _this.cfPay();
      })
    },
    // 常州纺织学院支付收银台
    cfPay: function () {
      let _this = this;
      this.$messagebox({
        title: '',
        $type: 'prompt',
        message: '请输入学生卡号',
        inputPattern: /^[0-9]*$/,
        inputErrorMessage: '请输入正确的学工号',
        inputValue: _this.schoolCardCode,
        showCancelButton: true,
        showInput: true
      }).then(({value, action}) => {
        this.schoolCardCode = value;
        let params = {
          cfOrderInfo: encodeURIComponent(JSON.stringify({accNum: value})),
          order_id: _this.orderId,
          payType: 92
        }
        actions.postWxJsPay(_this, params, function (data) {
          const div = document.createElement('div');
          div.innerHTML = data;
          document.body.appendChild(div);
          document.forms[0].submit();
        })
      })
    },
    clickHandle: function (type) {
      let _this = this
      window.localStorage.setItem('orderCode', _this.orderId);
      let param = {
        order_id: _this.orderId
      }
      if (type == 2) { //立即支付

//           if (_this.$utils.isWeiXin()) { // 判断是否微信浏览器中打开
//
//             _this.wxBridgeready();
//
//           } else {
//
//             window.localStorage.setItem('orderCode',_this.orderId)
//             _this.$router.push({path:'payment'})
//           }
        window.localStorage.setItem('orderCode', _this.orderId)
        // _this.$router.push({path:'payment'})
        // 常州纺织学院支付收银台
        let cfSchoolId;
        if (process.env.NODE_ENV == 'production') {
          cfSchoolId = 2803;
        } else {
          cfSchoolId = 1816;
        }
        if (cfSchoolId == _this.orderInfo.schoolId) {
          _this.getSchoolCardInfo();
        } else {
          _this.$indicator.open();//loading
          _this.$router.push({name: 'Payment'});
        }


      } else if (type == 3) { //确认收货

        actions.postFinalOrder(_this, param, function (data) {
          _this.getOrderDetail()
        })

      } else if (type == 4) { //查看配送进程

        window.localStorage.setItem('orderType', _this.orderInfo.orderType)
        if (_this.orderInfo.orderType == 1) {
          window.localStorage.setItem('pickupProcess', JSON.stringify(_this.orderInfo.flowList))
        }
        _this.$router.push({path: '/deliverydetail'})

      } else if (type == 5) { //去评价

        _this.$router.push({path: '/onlinecomment'})

      } else if (type == 6) { //查看评价
        // window.localStorage.setItem('estimateId', _this.estimateId);
        // window.localStorage.setItem('commentType', 0);
        // _this.$router.push({path: '/mycomment'})
      } else if (type == 1) { //申请售后
        _this.serviceList = true
      } else if (type == 7) {
        //是否为校园卡退款单子
        if (_this.orderInfo.refundNotice) {
          _this.$messagebox.confirm('', {
            title: '退款须知',
            message: _this.orderInfo.refundNotice,
            showCancelButton: true,
            confirmButtonText: '继续申请'
          }).then(action => {
            _this.$router.push({path: '/onlinerefund'})
          }).catch(err => {
          })
        } else {
          _this.$router.push({path: '/onlinerefund'})
        }
      } else if (type == 8) { //退款进度
        window.localStorage.setItem('processType', 0)
        window.localStorage.setItem('complainId', _this.complainId);
        _this.$router.push({path: 'checkcomplaints'})
      } else if (type == 9) { //在线投诉
        _this.$router.push({path: '/onlinecomplaints'})
      } else if (type == 10) { //投诉进度
        window.localStorage.setItem('processType', 1)
        window.localStorage.setItem('complainId', _this.complainId);
        _this.$router.push({path: 'checkcomplaints'})
      } else if (type == 11) {
        var params = {
          commercial_id: _this.orderInfo.commercialId,
          school_id: _this.orderInfo.schoolId
        };
        actions.getCommercialTel(_this, params, function (data) {
          _this.tel = data
        })
      }
    },
    wxBridgeready: function () {
      //开始调起微信支付
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', this.wxpay, false);

        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', this.wxpay);
          document.attachEvent('onWeixinJSBridgeReady', this.wxpay);
        }
      } else {
        this.wxpay();
      }
    },
    //微信支付
    wxpay: function () {
      var _this = this
      var u = window.location.href.split('#')[0];
      actions.getJslbsConf(this, u, function (data) {
        var wxappid = JSON.parse(data).appId
        var params = {
          order_id: _this.orderId,
          payType: 9,
          openid: _this.$store.state.openId,
          // type:1
        }
        actions.postWxJsPay(_this, params, function (redata) {
          _this.$indicator.close();
          WeixinJSBridge.invoke(
            'getBrandWCPayRequest', {
              "appId": wxappid,        //公众号名称，由商户传入
              "timeStamp": redata.timeStamp,     //时间戳，自1970年以来的秒数
              "nonceStr": redata.rndStr,     //随机串
              "package": redata.xpackage,
              "signType": "MD5",     //微信签名方式：
              "paySign": redata.sign       //微信签名
            },
            function (res) {
              if (res.err_msg == "get_brand_wcpay_request:ok") {
                let shopInfo = _this.$store.state.shopCodeInfo;
                let shopcode = shopInfo[_this.orderId];

                delete shopInfo[_this.orderId];
                _this.$store.commit('changeShopCodeInfo', shopInfo)
                delete _this.cartInfo[shopcode]
                _this.$store.commit('changeCartInfo', _this.cartInfo)
                _this.getOrderDetail()

              } else if (res.err_msg == 'get_brand_wcpay_request:cancel') {
                // _this.$messagebox.alert('支付失败！', '');
                alert('支付失败:' + JSON.stringify(res));

              } else {
                //alert(JSON.stringify(res))
                var u = navigator.userAgent;
                var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
                if (isAndroid) {
                  // _this.$messagebox.alert('支付失败！', '');
                  alert('支付失败:' + JSON.stringify(res));
                } else {
                  // _this.$messagebox.alert('支付失败！', '');
                  alert('支付失败:' + JSON.stringify(res));
                }
                _this.getOrderDetail()
              }
            }
          )
        }, function () {
          _this.$indicator.close();
        })
      })
    },
    H5pay: function () {
      var _this = this;
      var params = {
        order_id: _this.orderId,
        payType: 12 //公众号支付为9
      };
      actions.postWxJsPay(_this, params, function (data) {
        _this.$indicator.close();
        window.localStorage.setItem('orderCode', _this.orderId);
        // 跳转中间页
        let url = data.mwebUrl + '&redirect_url=' + encodeURIComponent(_this.$utils.getHost() + '/orderdetail');
        location.href = url;
      }, function (response) {
        // 响应错误回调
        _this.$indicator.close();
        if (response.data.message) {
          _this.$messagebox.alert(response.data.message, '');
        }
      })
    },
    //自提柜信息
    showSelfInfo() {
      this.isShowSelf = true;
    },
    //去打赏西游侠
    toReward(id) {
      window.localStorage.setItem('orderId', id);
      this.$router.push({name: 'Reward'});
    },
    //再来一单
    moreOrder: function (id, code, name) {
      var _this = this
      var obj = {
        shop_code: code,
        shop_name: name,
        showBlockType: 'orderDishes'
      }
      _this.$store.commit('changeState', obj)
      _this.anotherGoodsList = []
      _this.defaultGoodsList = []
      _this.changeGoodsInCart = []
      _this.shopDetail = {}

      // 获取店铺商品列表
      actions.getGoodsList(_this, {shop_id: code}, function (data) {
        _this.shopDetail = data.shop_detail;//店铺信息
        if(!_this.shopDetail.req_type) {
          data.item_list.forEach((item) => {
            if(item.goods_list && item.goods_list.length){
              item.goods_list = item.goods_list.map((secItem) => ({
                ...secItem,
                is_special_tag: item.is_special_tag,
                cateType: item.type
              }));
              _this.defaultGoodsList = _this.defaultGoodsList.concat(item.goods_list) // 商品总数据
            }
          });
        }
        // 获取再来一单商品
        _this.anotherGoodsList = _this.orderInfo.goods_list // 再来一单商品
        if(_this.shopDetail.req_type){
          if(_this.anotherGoodsList && _this.anotherGoodsList.length){
            var codesList = []
            _this.anotherGoodsList.forEach(item=>{
              codesList.push(item.gdCode+'')
            })
            var params = {
              codes: codesList,
              shopCode: code,
              specialTag: 0,
              token: _this.$store.state.wxToken
            };
            actions.getShopDetailList(_this, params, function (val) {
              _this.$indicator.close();
              var params1 = {
                shop_id: code,
                token: _this.$store.state.wxToken
              };
              actions.getGoodsList(_this, params1, function (val1) {
                var list = val1.item_list
                for(let k of list){
                  val.goods_list.forEach(secItem => {
                    if(secItem.tag_id == k.tag_id){
                      secItem.is_special_tag = k.is_special_tag
                      secItem.cateType = k.type
                    }
                  })
                }
                _this.defaultGoodsList = val.goods_list // 商品总数据
                _this.ToGoodsList(code,data.amount,data.real_pay,id)
              })
            })
          }
        }else{
          _this.ToGoodsList(code,data.amount,data.real_pay,id)
        }
      }, function () {
      })

    },
    ToGoodsList(code,amount,real_pay,id){
      var _this = this
      let marketObj = {}
      let totalAmount = 0
      _this.defaultGoodsList.filter((item) => item.is_special_tag === 0).forEach(firItem => {
        _this.anotherGoodsList.forEach(secItem => {
          if (secItem.isGift != 2) {
            let goodsInfo = {};
            let goodsId = secItem.skuCode;
            let specAttrStr = secItem.specification || '';
            if (firItem.gd_code === secItem.gdCode) {
              let attrIdArr = [];
              let attributes = [];
              // 判断商品名称改变
              if (secItem.name != firItem.goods_name) {
                let specificationName = secItem.specification || ''
                _this.changeGoodsInCart.push({id: secItem.skuCode, name: secItem.name + specificationName, num: 0})
                return
              }
              // 判断属性名称改变
              let attrsPrice = 0;
              if (secItem.attribute) {
                const totalAttr = _.flattenDeep(
                  firItem.attribute_list.map((item) => {
                    return item.attributeList.map((secItem) => ({
                      ...secItem,
                      attributeTypeId: item.attributeTypeId,
                      attributeTypeName: item.attributeTypeName
                    }))
                  })
                )
                let totalAttr1 = totalAttr.filter((item) => !item.skuCode || item.saleStatus == 1);
                const currentAttr = secItem.attribute.split('/');
                const isChange = !currentAttr.every((item) => _.find(totalAttr1, {name: item}));
                if (isChange) {
                  return _this.changeGoodsInCart.push({
                    id: secItem.skuCode,
                    name: secItem.name + (secItem.specification ? ('-' + secItem.specification) : '-') + secItem.attribute,
                    num: 0
                  });
                }
                attrIdArr = _.flattenDeep(
                  currentAttr.map((item) => {
                    const findObj = _.find(totalAttr, {name: item}) || {};
                    return [findObj.attributeTypeId, findObj.id]
                  })
                );
                attributes = currentAttr.map((item) => {
                  const findObj = _.find(totalAttr, {name: item}) || {};
                  if (findObj.salePrice) {
                    return {
                      id: findObj.attributeTypeId,
                      name: findObj.attributeTypeName,
                      attributeList: [{
                        id: findObj.id,
                        name: findObj.name,
                        salePrice: findObj.salePrice,
                        skuCode: findObj.skuCode
                      }]
                    }
                  } else {
                    return {
                      id: findObj.attributeTypeId,
                      name: findObj.attributeTypeName,
                      attributeList: [{
                        id: findObj.id,
                        name: findObj.name
                      }]
                    }
                  }
                });
                // 存在加价属性
                if (secItem.attributeSkuList && secItem.attributeSkuList.length > 0) {
                  let idArray = [];
                  let newAarray = [];
                  attributes.forEach(function (ele, i) {
                    if (idArray.indexOf(attributes[i].id) === -1) {
                      newAarray.push(attributes[i])
                      idArray.push(attributes[i].id);
                    } else {
                      newAarray.forEach(function (dom, k) {
                        if (newAarray[k].id == attributes[i].id) {
                          newAarray[k].attributeList.push(attributes[i].attributeList[0]);
                        }
                      })
                    }
                  })
                  attributes = newAarray;
                  for (let v of secItem.attributeSkuList) {
                    for (let v1 of totalAttr) {
                      if (v1.skuCode == v.skuCode) {
                        attrsPrice = (parseFloat(attrsPrice) + parseFloat(v1.salePrice)).toFixed(2);
                      }
                    }
                  }

                }
                if (specAttrStr.length > 0) {
                  specAttrStr += '/' + secItem.attribute
                } else {
                  specAttrStr = secItem.attribute
                }
              }
              let findSku = {};
              for (let obj of firItem.sku_list) {
                if (obj.sku_id == goodsId) {
                  findSku = {...obj};
                  // 整理购物车数据
                  let singleTotalPrice = 0
                  let singleOriginPrice = 0 // 单个商品现总价和原总价
                  let noStock = false
                  // let findSku = _.find(firItem.sku_list, {sku_id: goodsId});

                  if (secItem.specification && secItem.specification.length > 0) {
                    // 判断规格名称改变
                    let specification = secItem.specification.substring(0, secItem.specification.indexOf('/')) || secItem.specification
                    // let specFlag = 0
                    // firItem.sku_list.forEach(thirdItem => {
                    //   if (thirdItem.sku_id == secItem.skuCode && thirdItem.specification === specification) {
                    //     specFlag++
                    //   }
                    // })
                    if (findSku.specification != specification) {
                      _this.changeGoodsInCart.push({
                        id: secItem.skuCode,
                        name: secItem.name + secItem.specification,
                        num: 0
                      })
                      return
                    }
                  }

                  // 判断库存
                  if (findSku.stock === 0) {
                    let specificationName = secItem.specification || ''
                    _this.changeGoodsInCart.push({
                      id: secItem.skuCode,
                      name: secItem.name + specificationName,
                      num: 0
                    })
                    return
                  }
                  if (findSku.stock < secItem.buyNum) {
                    noStock = true // 无库存
                    let specificationName = secItem.specification || ''
                    _this.changeGoodsInCart.push({
                      id: secItem.skuCode,
                      name: secItem.name + specificationName,
                      num: findSku.stock
                    })
                    totalAmount += findSku.stock
                  } else {
                    noStock = false // 有库存
                    totalAmount += secItem.buyNum
                  }
                  // 计算活动价格
                  if (attrsPrice > 0) {
                    findSku.activity_price = (parseFloat(findSku.activity_price) + parseFloat(attrsPrice)).toFixed(2);
                    findSku.sales_price = (parseFloat(findSku.sales_price) + parseFloat(attrsPrice)).toFixed(2);
                  }
                  if (findSku.num_per_goods > 0) { // 是活动商品
                    singleTotalPrice = (findSku.activity_price * findSku.num_per_goods + findSku.sales_price * (secItem.buyNum - findSku.num_per_goods)).toFixed(2)
                  } else { // 无活动商品
                    singleTotalPrice = (findSku.sales_price * secItem.buyNum).toFixed(2)
                  }
                  singleOriginPrice = (findSku.sales_price * secItem.buyNum).toFixed(2) // 单个折扣商品的总原价
                  goodsInfo = {
                    activeBuyNum: findSku.num_per_goods, // 活动商品限购数量
                    activePrice: findSku.activity_price,
                    activityId: findSku.activity_id,
                    cartNum: noStock ? findSku.stock : secItem.buyNum,
                    cateType: firItem.cateType, // 商品是否限购
                    gdName: secItem.name,
                    is_single_spec: firItem.is_single_spec, // 是否为单规格
                    noStock: noStock,
                    original_tag_id: firItem.tag_id,
                    restriction_num: firItem.restriction_num, // 限购数量
                    restriction_type: firItem.restriction_type, // 限购类型 0-不限购；1-每单限购
                    salePrice: findSku.sales_price,
                    singleOriginPrice: singleOriginPrice,
                    singleTotalPrice: singleTotalPrice,
                    sku_id: secItem.skuCode,
                    sku_list: firItem.sku_list,
                    specification: {id: findSku.specification_id, name: findSku.specification}, // 规格
                    specifications: findSku,
                    stock: findSku.stock,
                    tag_id1: firItem.tag_id,
                    goodsNum: findSku.num_per_goods,
                    orderNum: findSku.num_per_order,
                    leftNum: findSku.left_stock,
                    specAttrStr: specAttrStr,
                    attributes: attributes,
                    attrIdArr: _.uniq(attrIdArr),
                    packing_fee: firItem.packing_fee,
                    packing_fee_rule: firItem.packing_fee_rule,
                    gd_code: firItem.gd_code,
                  };
                  marketObj[goodsId] = [
                    ..._.get(marketObj, goodsId, []),
                    goodsInfo
                  ];
                }
              }
            }
          }
        })
      })
      _this.cartInfo[code] = {
        total: totalAmount,
        amount: amount,
        market: marketObj,
        originAmount: real_pay
      }
      // 下架商品
      _this.anotherGoodsList.filter((item) => !_.find(_this.defaultGoodsList, {gd_code: item.gdCode})).forEach(item => {
        if(item.isGift != 2){
          // 去除加价购商品
          let specificationName = item.specification || ''
          _this.changeGoodsInCart.push({id: item.skuCode, name: item.name + specificationName, num: 0})
          return;
        }
      })
      window.localStorage.setItem('changeGoodsInCart', JSON.stringify(_.uniqWith(_this.changeGoodsInCart, _.isEqual)))
      _this.$store.commit('changeCartInfo', _this.cartInfo) // 更新购物车总价信息
      _this.$router.push({name: 'GoodsList', params: {orderCode: id}})
    },
    // 幸福星期天
    isShowHappySunday() {
      let _this = this
      let params = {
        school_id: _this.orderInfo.schoolId
      }
      actions.getHappySundayShow(_this, params, function (res) {
        if(res && res.activityStatus && res.activityStatus === 1){
          _this.showHappySunday = true;
        }
      }, function () {

      })
    },
    // 查看准时达保障内容
    viewPunctual() {
      this.$router.push({name: 'PunctualArrive', query: { orderId: this.orderId}})
    }
  }
}
</script>
<style scoped>
/*订餐进程开始*/
.dialog-order {
  position: relative;
  width: 80%;
  height: auto;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  background-color: #ffffff;
}

.mydialog {
  padding-top: 0.3rem;
}

.mybnt {
  padding-bottom: 0.3rem;
  text-align: center;
  color: #1989fa;
}

.dialog-order ul li {
  padding: 0.01rem;
  position: relative;
  float: left;
  color: #676767;
  width: 100%;
  height: 66px;
}

.dialog-order .icon {
  padding: 0.1rem 0.5rem;
  background-size: auto 0.4rem;
  background-repeat: no-repeat;
  background-position: center top;
  color: #000000;
  position: relative;
}

.dialog-order .icon:before {
  content: '';
  width: 0.14rem;
  height: 0.14rem;
  border-radius: 1rem;
  background-color: #676767;
  display: block;
  position: absolute;
  top: .2rem;
  left: .2rem;
}

.dialog-order .icon:after {
  position: absolute;
  content: '';
  height: 1px;
  background-color: #979797;
  width: 16%;
  transform: rotate(270deg);
  top: .86rem;
  left: -0.2rem;
}

.dialog-order ul li:last-child .icon:before {
  background-color: #ffd01e;
}

.dialog-order ul li:last-child .icon:after {
  height: 0;
}

.order-cards {
  width: 100%;
  height: 1rem;
  margin: .1rem;
  display: flex;
  flex-direction: column;
}

.cards-first {
  width: 8rem;
}

.cards-title {
  float: left;
  width: 46%;
}

.cards-sec {
  padding-top: 0.1rem;
  color: #a09f9f;
}

.orderProgress {
  padding: 0.3rem 0.2rem;
  margin-bottom: 0.2rem;
  border-radius: 0.2rem;
  background-color: #fff;
}

.subTitle {
  font-weight: 600;
  margin-bottom: 0.2rem;
}

.progress-contain a {
  margin-right: .2rem;
}

/*订餐进程结束*/

.br20 {
  border-radius: .2rem;
}

.list ul li {
  background-color: transparent;
}

.list ul {
  background-color: #fff;
}

.list .order-id {
  font-size: .22rem;
  color: #797979;
}
.back-luck-sunday{
  position: absolute;
  right: .26rem;
  top: .5rem;
  padding: 0 .22rem;
  background: #FFDF00;
  height: .6rem;
  line-height: .6rem;
  border-radius: .72rem;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// OrderDetail.vue?5f8cd36c